"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyClassDto = instanceOfPropertyClassDto;
exports.PropertyClassDtoFromJSON = PropertyClassDtoFromJSON;
exports.PropertyClassDtoFromJSONTyped = PropertyClassDtoFromJSONTyped;
exports.PropertyClassDtoToJSON = PropertyClassDtoToJSON;
exports.PropertyClassDtoToJSONTyped = PropertyClassDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyClassDto interface.
 */
function instanceOfPropertyClassDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('internalName' in value) || value['internalName'] === undefined)
        return false;
    return true;
}
function PropertyClassDtoFromJSON(json) {
    return PropertyClassDtoFromJSONTyped(json, false);
}
function PropertyClassDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'internalName': json['internalName'],
    };
}
function PropertyClassDtoToJSON(json) {
    return PropertyClassDtoToJSONTyped(json, false);
}
function PropertyClassDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'internalName': value['internalName'],
    };
}
